import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadPrices } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { loadUnpagedGrades } from '../grades/actions';

class Prices extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadGrades();
		
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}

	loadGrades() {
		const { loadUnpagedGrades } = this.props;
		loadUnpagedGrades();
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		const { isReadonly, gradesList, workWithKindergarten, paymentTypes, enableTermPrice, enableTrials } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} grades={gradesList} workWithKindergarten={workWithKindergarten} loading={this.props.pagination.loading}/>
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} enableTrials={enableTrials}
					paymentTypes={paymentTypes} enableTermPrice={enableTermPrice} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { prices, grades },
		lookups: { paymentTypes},
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const pricesPagination = pagination.prices.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: pricesPagination.ids.map(id => prices[id]),
		pagination: pricesPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Prices'),
		gradesList: grades,
		workWithKindergarten: franchisor.workWithKindergarten,
		paymentTypes,
		enableTermPrice: franchisor.enableTermPrice,
		enableTrials: franchisor.enableTrials
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadPrices,
	initializeFilter: (data, fields) => initialize('pricesFilter', data, fields),
	loadUnpagedGrades
})(Prices);